import __pages_import_0__ from "/src/pages/index.vue";
const __pages_import_1__ = () => import("/src/pages/login.vue");
const __pages_import_2__ = () => import("/src/pages/song/[id].vue");

const routes = [{"name":"index","path":"/","component":__pages_import_0__,"props":true},{"name":"login","path":"/login","component":__pages_import_1__,"props":true,"meta":{"layout":"blank"}},{"name":"song-id","path":"/song/:id","component":__pages_import_2__,"props":true}];

export default routes;